export default __webpack_public_path__ + "static/media/info-circle.f408d8b7.svg";